import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Radio as MuiRadio, FormControlLabel } from '@mui/material'
import { Box } from '@mui/system'

import SwitchLabel from '../../../ui/components/switchLabel'

import useStyles from './styles'

const RadioPreview = ({
  label,
  subLabel,
  disabled,
  image,
  className,
  value,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.wrapper}>
      <FormControlLabel
        className={clsx(className, classes.container)}
        value={value}
        label={
          <SwitchLabel label={label} subLabel={subLabel} disabled={disabled} />
        }
        control={<MuiRadio />}
        disabled={disabled}
      />
      {image ? (
        <Box className={classes.imageContainer}>
          <img src={image} alt="" />
        </Box>
      ) : null}
    </Box>
  )
}

RadioPreview.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  image: PropTypes.elementType.isRequired,
}

export default RadioPreview
